export function isNestedFieldHidden(question, fieldKey) {
  const fieldConfig = question?.config?.fields?.[fieldKey] || {}
  return !!fieldConfig.hidden
}
